import styled from "@emotion/styled";
import { useMatch } from "react-router-dom";
import Logo from "../assets/logo-aden.png";

const NavBar = () => {
    const isRepoEvent = !!useMatch("/evento/repo/:id");

    return (
        <Container isRepoEvent={isRepoEvent}>
            <img src={Logo} alt="Logo ADEN" />
        </Container>
    );
};

export default NavBar;

const Container = styled.div`
    width: 100%;
    background-color: #b31d15;
    height: ${(p) => (p.isRepoEvent ? "70px" : "130px")};
    display: flex;
    justify-content: center;
    align-items: center;

    img {
        width: ${(p) => (p.isRepoEvent ? "180px" : "300px")};
    }
`;
